module.exports = __webpack_public_path__ + "img/PR2311.6e0ec67a.png";